/* eslint-disable @typescript-eslint/no-explicit-any */
import useIsMobile from '@/hooks/useIsMobile';
import { useReportingToolsStore } from '@/pages/reporting-tools/store/useReportingToolsStore';
import { useQuery, useSuspenseQuery } from '@apollo/client';
import {
  FetchReportingToolsMissionTraitAnalysisQuery,
  FetchReportingToolsMissionTraitAnalysisQueryVariables,
  FETCH_REPORTING_TOOLS_MISSION_TRAIT_ANALYSIS,
  MissionTraitAnalysis,
  FETCH_TRAITS,
  FetchTraitsQuery,
  FetchTraitsQueryVariables,
} from '@edwin-group/cj-graphql';
import { ChartData } from 'chart.js';
import { useEffect, useState, useDeferredValue } from 'react';
import { parseMissionTraitAnalysis } from '../chart/parse';

export const useMissionTraitAnalysis = () => {
  const [radarData, setRadarData] = useState<ChartData<'radar'>>({ datasets: [] });
  const { isMobile } = useIsMobile();

  const { data: traitsData } = useQuery<FetchTraitsQuery, FetchTraitsQueryVariables>(FETCH_TRAITS, {
    fetchPolicy: 'cache-and-network',
  });
  const filtersStore = useReportingToolsStore((state) => state.filters);
  const filters = useDeferredValue(filtersStore);
  const isPending = filtersStore !== filters;

  const { data, error } = useSuspenseQuery<
    FetchReportingToolsMissionTraitAnalysisQuery,
    FetchReportingToolsMissionTraitAnalysisQueryVariables
  >(FETCH_REPORTING_TOOLS_MISSION_TRAIT_ANALYSIS, {
    fetchPolicy: 'cache-and-network',
    variables: {
      schoolDocumentIds: filters.schoolDocumentIds,
      academicYear: filters.academicYear,
      cohortDocumentIds: filters.cohortDocumentIds,
    },
    errorPolicy: 'all',
  });

  useEffect(() => {
    if (data) {
      const reportData = data.fetchReportingToolsMissionTraitAnalysis?.missionTraitAnalysis as MissionTraitAnalysis[];
      setRadarData(parseMissionTraitAnalysis(reportData, traitsData as FetchTraitsQuery));
      return;
    }
    setRadarData({ datasets: [] });
  }, [data, traitsData]);

  return { radarData, traitsData, isMobile, error, isPending };
};
